import { useState } from "react";
import { toggleMute, isMuted, sfx } from "../lib/soundEngine";

export const Header = ({ onReset }) => {
    const [muted, setMutedState] = useState(isMuted());

    const handleMute = () => {
        const m = toggleMute();
        setMutedState(m);
        if (!m) sfx.click();
    };

    const scrollTo = (id) => (e) => {
        e.preventDefault();
        sfx.click();
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <header id="top" className="arcade-header sticky top-0 z-50 w-full">
            <div className="max-w-7xl mx-auto px-5 md:px-8 py-3 flex items-center justify-between">
                <a
                    href="#top"
                    onClick={scrollTo("top")}
                    data-testid="header-logo-link"
                    className="flex items-center gap-3 group"
                >
                    <span
                        className="inline-flex items-center justify-center w-10 h-10 rounded-lg border-2 border-neon-cyan"
                        style={{ borderColor: "var(--neon-cyan)" }}
                        aria-hidden="true"
                    >
                        <i className="fa-solid fa-gamepad neon-cyan text-lg" />
                    </span>
                    <span className="font-pixel text-2xl md:text-3xl neon-cyan tracking-widest">
                        METE&apos;S SITE
                    </span>
                </a>

                <nav className="flex items-center gap-3 md:gap-5">
                    <a
                        href="#games"
                        onClick={scrollTo("games")}
                        data-testid="header-nav-games"
                        className="font-pixel text-lg md:text-xl neon-amber hover:opacity-80 transition-opacity px-2"
                    >
                        GAMES
                    </a>
                    <button
                        onClick={handleMute}
                        data-testid="header-audio-toggle"
                        aria-label={muted ? "Unmute sound" : "Mute sound"}
                        className="font-pixel text-lg md:text-xl neon-pink hover:opacity-80 transition-opacity px-2"
                    >
                        <i className={`fa-solid ${muted ? "fa-volume-xmark" : "fa-volume-high"} mr-2`} />
                        {muted ? "MUTED" : "AUDIO"}
                    </button>
                    <button
                        onClick={() => { sfx.coin(); onReset && onReset(); }}
                        data-testid="header-reset-all"
                        className="hidden sm:inline-flex font-pixel text-lg md:text-xl neon-lime hover:opacity-80 transition-opacity px-2"
                    >
                        <i className="fa-solid fa-rotate-right mr-2" />
                        RESET
                    </button>
                </nav>
            </div>
        </header>
    );
};
